import NavigationContext from "context/NavigationContext";
import { useGenerateKonjToken, useKonjUserInfo } from "hooks/useAuth";
import React from "react";
import { Button, Nav, Navbar, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BsArrowRightShort } from "react-icons/bs";
import { VscMenu } from "react-icons/vsc";
import { useHistory, withRouter } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { CookieUtils } from "utils";
import "./Header.scss";

const Header = ({
  title,
  disableMenu = false,
  konjExit = false,
  showBack = false,
}) => {
  const history = useHistory();

  const token = new CookieUtils().getCookie("token");

  /* eslint-disable  no-empty-pattern */ const {} = useKonjUserInfo(
    token,
    history.location.pathname.search("konj") !== -1
  );
  const konjToken = new CookieUtils().getCookie("konjToken");

  const { isLoading, mutate } = useGenerateKonjToken({
    onError,
  });

  function onError(err) {
    toast.error(err);
  }

  const { t } = useTranslation();
  const { handleDrawerToggle } = React.useContext(NavigationContext);

  // const handleChange = (selectedOption) => {
  //   i18n.changeLanguage(selectedOption.value);
  //   setState({ ...state, selectedOption });
  //   dispatch(themeDirectionFunc(selectedOption.value === "fa" ? "rtl" : ""));
  //   // console.log(`Option selected:`, selectedOption);
  // };

  // const { selectedOption } = state;

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      bg="light"
      variant="light"
      className="shadow-sm border-bottom sticky-top"
      style={{ zIndex: 20 }}
    >
      <ToastContainer />
      <div>
        {!disableMenu && (
          <Button
            type="button"
            className="mr-3 cu-text-lg py-0 bg-transparent text-dark border-0 pl-0"
            onClick={handleDrawerToggle}
          >
            <VscMenu />
          </Button>
        )}
        {showBack && (
          <Button
            type="button"
            className=" cu-text-lg py-0 bg-transparent text-dark border-0 pl-0"
            onClick={() => history.goBack()}
          >
            <BsArrowRightShort />
          </Button>
        )}
        <Navbar.Brand
          // href="http://edu.dayamooz.com"
          target="_blank"
          className="mr-2"
        >
          {title}
        </Navbar.Brand>
      </div>
      <div className="ml-auto d-flex align-items-center">
        <Nav>
          {konjExit &&
            konjToken &&
            (isLoading ? (
              <Spinner animation="border" />
            ) : (
              <Button
                onClick={() => {
                  mutate();
                }}
                variant="outline-danger"
              >
                {t("remove-konj-sync")}
              </Button>
            ))}
        </Nav>

        {/* <div
          className={clsx(
            "direction-ltr",
            themeDirection === "rtl" && "text-right"
          )}
          style={{ width: "85px" }}
        >
          <Select
            value={selectedOption}
            onChange={handleChange}
            // options={i18n.languages.map((item) => ({
            //   label: item.toUpperCase(),
            //   value: item,
            // }))}
            options={[
              { label: "FA", value: "fa" },
              { label: "EN", value: "en" },
            ]}
            name="language"
            isSearchable={false}
          />
        </div> */}
      </div>
    </Navbar>
  );
};

export default withRouter(Header);
